import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

/**
 * Serviço responsável por realizar as requisições para monitorar o status do equipamento.
 */
@Injectable({
    providedIn: "root"
})
export class DeviceMonitoringService {
    private readonly baseUrl: string;

    constructor(private readonly http: HttpClient) {
        this.baseUrl = "/service/device/monitoring";
    }

    getMonitoringStatus(resourceId: number): Observable<string> {
        const url = `${this.baseUrl}/${resourceId}`;

        return this.http.get(url, { responseType: "text" });
    }
}
